import React from "react";
import {
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const ReportDetailsAngle = ({ data, numberFormatter, currencyFormatter }) => {
  const useStyles = makeStyles(() => ({
    header: {
      backgroundColor: "#445851",
      border: "1px solid white",
      borderBottom: 0,
      color: "white",
      padding: 8,
    },
    cell: {
      border: "1px solid #c7c7c7",
      padding: 8,
    },
    center: {
      textAlign: "center",
    },
  }));

  const classes = useStyles();

  const StyledHeader = (title, width, textAlign) => (
    <TableCell
      className={classes.header}
      style={{
        width,
        textAlign,
      }}
    >
      {" "}
      {title}{" "}
    </TableCell>
  );

  const StyledCell = (value, textAlign) => (
    <TableCell
      className={classes.cell}
      style={{
        textAlign,
      }}
    >
      {" "}
      {value}{" "}
    </TableCell>
  );

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {" "}
            {StyledHeader("Laptop", "9%")} {StyledHeader("Angle", "10%")}{" "}
            {StyledHeader("Ad Account Status", "7%")}{" "}
            {StyledHeader("Visits", "6%", "right")}{" "}
            {StyledHeader("Clicks", "6%", "right")}{" "}
            {StyledHeader("Conversions", "5%", "right")}{" "}
            {StyledHeader("Revenue", "8%", "right")}{" "}
            {StyledHeader("Cost", "8%", "right")}{" "}
            {StyledHeader("Profit", "8%", "right")}{" "}
            {StyledHeader("ROAS", "5%", "right")}{" "}
            {StyledHeader("CTR", "6%", "right")}{" "}
            {StyledHeader("CV", "6%", "right")}{" "}
            {StyledHeader("AP", "6%", "right")}{" "}
          </TableRow>{" "}
        </TableHead>
        <TableBody>
          {" "}
          {data.length > 0 ? (
            data.map((angle, index) => (
              <TableRow key={index}>
                {" "}
                {StyledCell(angle.laptop)} {StyledCell(angle.angle)}{" "}
                {StyledCell(angle.ad_account_status)}{" "}
                {StyledCell(numberFormatter.format(angle.visits), "right")}{" "}
                {StyledCell(numberFormatter.format(angle.clicks), "right")}{" "}
                {StyledCell(numberFormatter.format(angle.conversions), "right")}{" "}
                {StyledCell(
                  `${currencyFormatter.format(angle.revenue)}`,
                  "right"
                )}{" "}
                {StyledCell(`${currencyFormatter.format(angle.cost)}`, "right")}{" "}
                {StyledCell(
                  <span
                    style={{
                      color:
                        +angle.profit < 0
                          ? "red"
                          : +angle.profit > 0
                          ? "green"
                          : "black",
                    }}
                  >
                    {currencyFormatter.format(angle.profit)}{" "}
                  </span>,
                  "right"
                )}{" "}
                {StyledCell(angle.ROAS, "right")}{" "}
                {StyledCell(`${angle.CTR}%`, "right")}{" "}
                {StyledCell(`${angle.CV}%`, "right")}{" "}
                {StyledCell(currencyFormatter.format(angle.AP), "right")}{" "}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} className={classes.center}>
                No records to display{" "}
              </TableCell>{" "}
            </TableRow>
          )}{" "}
        </TableBody>{" "}
      </Table>{" "}
    </TableContainer>
  );
};

export default ReportDetailsAngle;
